import { useTranslation } from "react-i18next";

type TProps = {
  message?: string;
  description?: string;
  className?: string;
};

export const NoResultFound: React.FC<TProps> = ({
  message = "sorryNoResult",
  description,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`no-result-found text-center py-3 px-2 ${className}`.trim()}
      id="noresult"
    >
      <div className="avatar-xs mx-auto mb-2">
        <span className="avatar-title rounded-circle bg-light text-muted">
          <i className="ri-inbox-2-line fs-16" />
        </span>
      </div>
      <p className="fw-medium text-body mb-0 fs-13">{t(message)}</p>
      {description ? (
        <p className="text-muted mb-0 mt-1 fs-12">{t(description)}</p>
      ) : null}
    </div>
  );
};
